import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from "C4";
import { baseAppId, storageKeys } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Multiselect } from "multiselect-react-dropdown";
import i18n from "i18n-react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";

let containerStyle = {
  width: "100%",
  height: "calc(100vh - 8rem)",
};
const params = new URLSearchParams(window.location.search);
if (params.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 19.198959308653567,
      lat2: 17.2371789752111,
      lon1: -65.11873176367187,
      lon2: -67.46156623632812,
      loading: false,
      query: "",
      category: "",
      subcategory: "",
      michelin: "",
      rating: "",
      cuisine: "",
      width: null,
      mobile: false,
      zoom: 9,
      center: {
        lat: 18.220833,
        lng: -66.290149,
      },
      color: "16638b",
      font: "Source Sans Pro",
      userInfo: "",
      language: "en",
      categories: [
        {
          name: i18n.translate("categories.all"),
          id: "All",
          value: "All",
        },
        {
          name: i18n.translate("categories.sportshobbiesactivities"),
          id: "Sports, Hobbies & Activities",
          value: "Sports, Hobbies & Activities",
        },
        {
          name: i18n.translate("categories.landmarkspointsofinterest"),
          id: "Landmarks & Points of Interest",
          value: "Landmarks & Points of Interest",
        },
        {
          name: i18n.translate("categories.volunteeropportunities"),
          id: "Volunteer Opportunities",
          value: "Volunteer Opportunities",
        },
        {
          name: i18n.translate("categories.accommodations"),
          id: "Accommodations",
          value: "Accommodations",
        },
        {
          name: i18n.translate("categories.attractions"),
          id: "Attractions",
          value: "Attractions",
        },
        {
          name: i18n.translate("categories.dining"),
          id: "Dining",
          value: "Dining",
        },
        {
          name: i18n.translate("categories.eventservices"),
          id: "Event Services",
          value: "Event Services",
        },
        {
          name: i18n.translate("categories.eventvenues"),
          id: "Event Venues",
          value: "Event Venues",
        },
        {
          name: i18n.translate("categories.medicaltourism"),
          id: "Medical Tourism",
          value: "Medical Tourism",
        },
        {
          name: i18n.translate("categories.museums"),
          id: "Museums",
          value: "Museums",
        },
        {
          name: i18n.translate("categories.nightlife"),
          id: "Nightlife",
          value: "Nightlife",
        },
        {
          name: i18n.translate("categories.shopping"),
          id: "Shopping",
          value: "Shopping",
        },
        {
          name: i18n.translate("categories.sportsmarketing"),
          id: "Sports Marketing",
          value: "Sports Marketing",
        },
        {
          name: i18n.translate("categories.tours"),
          id: "Tours",
          value: "Tours",
        },
        {
          name: i18n.translate("categories.transportation"),
          id: "Transportation",
          value: "Transportation",
        },
        {
          name: i18n.translate("categories.wellness"),
          id: "Wellness",
          value: "Wellness",
        },
      ],
      subcategories: {
        sportshobbiesactivities: [
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.scubadiving"
            ),
            id: "Sports, Hobbies & Activities: Scuba Diving",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.snorkeling"
            ),
            id: "Sports, Hobbies & Activities: Snorkeling",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.sup"),
            id: "Sports, Hobbies & Activities: SUP / Paddleboarding",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.fishing"),
            id: "Sports, Hobbies & Activities: Fishing",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.camping"),
            id: "Sports, Hobbies & Activities: Camping",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.trekkinghiking"
            ),
            id: "Sports, Hobbies & Activities: Trekking & Hiking",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.kayaking"),
            id: "Sports, Hobbies & Activities: Kayaking",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.riverrafting"
            ),
            id: "Sports, Hobbies & Activities: River Rafting",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.rivertubing"
            ),
            id: "Sports, Hobbies & Activities: River Tubing",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.ziplining"
            ),
            id: "Sports, Hobbies & Activities: Ziplining",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.miniaturegolf"
            ),
            id: "Sports, Hobbies & Activities: Miniature Golf",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.jetskiing"
            ),
            id: "Sports, Hobbies & Activities: Jet Skiing",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.otherwatersports"
            ),
            id: "Sports, Hobbies & Activities: Other Watersports",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.rappelling"
            ),
            id: "Sports, Hobbies & Activities: Rappelling",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.bowling"),
            id: "Sports, Hobbies & Activities: Bowling",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.recreationalwalking"
            ),
            id: "Sports, Hobbies & Activities: Recreational Walking",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.surfinglessons"
            ),
            id: "Sports, Hobbies & Activities: Surfing Lessons",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.golf"),
            id: "Sports, Hobbies & Activities: Golf",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.biking"),
            id: "Sports, Hobbies & Activities: Biking",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.bikingtrails"
            ),
            id: "Sports, Hobbies & Activities: Biking Trails",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.paintball"
            ),
            id: "Sports, Hobbies & Activities: Paintball",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.fourwheeleratvs"
            ),
            id: "Sports, Hobbies & Activities: 4-Wheeler / ATVs",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.surfingequipment"
            ),
            id: "Sports, Hobbies & Activities: Surfing Equipment",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.horsebackriding"
            ),
            id: "Sports, Hobbies & Activities: Horseback Riding",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.sailing"),
            id: "Sports, Hobbies & Activities: Sailing",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.birding"),
            id: "Sports, Hobbies & Activities: Birding",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.surfspots"
            ),
            id: "Sports, Hobbies & Activities: Surf Spots",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.rockclimbing"
            ),
            id: "Sports, Hobbies & Activities: Rock Climbing",
          },
          {
            name: i18n.translate("categories.sportshobbiesactivities.gokarts"),
            id: "Sports, Hobbies & Activities: Go-Karts",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.boatrentalscharters"
            ),
            id: "Sports, Hobbies & Activities: Boat Rentals & Charters",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.cavetubing"
            ),
            id: "Sports, Hobbies & Activities: Cave Tubing",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.windsurfing"
            ),
            id: "Sports, Hobbies & Activities: Windsurfing",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.kitesurfing"
            ),
            id: "Sports, Hobbies & Activities: Kitesurfing / Kiteboarding",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.hanggliding"
            ),
            id: "Sports, Hobbies & Activities: Hang Gliding",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.scenicflights"
            ),
            id: "Sports, Hobbies & Activities: Scenic Flights",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.parasailing"
            ),
            id: "Sports, Hobbies & Activities: Parasailing",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.skydiving"
            ),
            id: "Sports, Hobbies & Activities: Skydiving",
          },
          {
            name: i18n.translate(
              "categories.sportshobbiesactivities.balloonrides"
            ),
            id: "Sports, Hobbies & Activities: Balloon Rides",
          },
        ],
        landmarkspointsofinterest: [
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.architecturalsites"
            ),
            id: "Landmarks & Points of Interest: Architectural Sites",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.nationalregister"
            ),
            id: "Landmarks & Points of Interest: U.S. National Register of Historic Places Listings",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.beaches"
            ),
            id: "Landmarks & Points of Interest: Beaches",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.playgrounds"
            ),
            id: "Landmarks & Points of Interest: Playgrounds",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.townhalls"
            ),
            id: "Landmarks & Points of Interest: Town Halls",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.housesofimportantfigures"
            ),
            id: "Landmarks & Points of Interest: Houses of Important Figures",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.photospotsviewpoints"
            ),
            id: "Landmarks & Points of Interest: Photo Spots / Viewpoints",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.citytownplazas"
            ),
            id: "Landmarks & Points of Interest: City / Town Plazas",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.ruinsabandonedplaces"
            ),
            id: "Landmarks & Points of Interest: Ruins & Abandoned Places",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.fortresses"
            ),
            id: "Landmarks & Points of Interest: Fortresses",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.historicwalkingareas"
            ),
            id: "Landmarks & Points of Interest: Historic Walking Areas",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.publicparks"
            ),
            id: "Landmarks & Points of Interest: Public Parks",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.rivers"),
            id: "Landmarks & Points of Interest: Rivers",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.lakes"),
            id: "Landmarks & Points of Interest: Lakes",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.archaeologicalsites"
            ),
            id: "Landmarks & Points of Interest: Archaeological Sites",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.lighthouses"
            ),
            id: "Landmarks & Points of Interest: Lighthouses",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.bays"),
            id: "Landmarks & Points of Interest: Bays",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.churchesreligiouscenters"
            ),
            id: "Landmarks & Points of Interest: Churches & Religious Centers",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.libraries"
            ),
            id: "Landmarks & Points of Interest: Libraries",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.statues"
            ),
            id: "Landmarks & Points of Interest: Statues",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.forests"
            ),
            id: "Landmarks & Points of Interest: Forests",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.mountains"
            ),
            id: "Landmarks & Points of Interest: Mountains",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.swimmingholes"
            ),
            id: "Landmarks & Points of Interest: Swimming Holes",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.boardwalks"
            ),
            id: "Landmarks & Points of Interest: Boardwalks",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.naturalsprings"
            ),
            id: "Landmarks & Points of Interest: Natural Springs",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.caves"),
            id: "Landmarks & Points of Interest: Caves",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.indigenoussites"
            ),
            id: "Landmarks & Points of Interest: Indigenous Sites",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.monuments"
            ),
            id: "Landmarks & Points of Interest: Monuments",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.bioluminescentbays"
            ),
            id: "Landmarks & Points of Interest: Bioluminescent Bays",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.coffeeplantations"
            ),
            id: "Landmarks & Points of Interest: Coffee Plantations",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.murals"),
            id: "Landmarks & Points of Interest: Murals",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.canyons"
            ),
            id: "Landmarks & Points of Interest: Canyons",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.inscribedrocks"
            ),
            id: "Landmarks & Points of Interest: Inscribed Rocks",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.waterfalls"
            ),
            id: "Landmarks & Points of Interest: Waterfalls",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.theaters"
            ),
            id: "Landmarks & Points of Interest: Theaters",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.universitiesschools"
            ),
            id: "Landmarks & Points of Interest: Universities & Schools",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.visitorcenters"
            ),
            id: "Landmarks & Points of Interest: Visitor Centers",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.castles"
            ),
            id: "Landmarks & Points of Interest: Castles",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.legendsghosts"
            ),
            id: "Landmarks & Points of Interest: Legends & Ghosts",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.historicestates"
            ),
            id: "Landmarks & Points of Interest: Historic Estates",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.unescoheritagesites"
            ),
            id: "Landmarks & Points of Interest: UNESCO Heritage Sites",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.bridges"
            ),
            id: "Landmarks & Points of Interest: Bridges",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.islands"
            ),
            id: "Landmarks & Points of Interest: Islands",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.cays"),
            id: "Landmarks & Points of Interest: Cays",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.marinasyachtclubs"
            ),
            id: "Landmarks & Points of Interest: Marinas / Yacht Clubs",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.cemeteriesmausoleums"
            ),
            id: "Landmarks & Points of Interest: Cemeteries & Mausoleums",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.lagoons"
            ),
            id: "Landmarks & Points of Interest: Lagoons",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.reefs"),
            id: "Landmarks & Points of Interest: Reefs",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.towers"),
            id: "Landmarks & Points of Interest: Towers",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.gardens"
            ),
            id: "Landmarks & Points of Interest: Gardens",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.farms"),
            id: "Landmarks & Points of Interest: Farms",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.fountains"
            ),
            id: "Landmarks & Points of Interest: Fountains",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.ranches"
            ),
            id: "Landmarks & Points of Interest: Ranches",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.sculptures"
            ),
            id: "Landmarks & Points of Interest: Sculptures",
          },
          {
            name: i18n.translate("categories.landmarkspointsofinterest.dams"),
            id: "Landmarks & Points of Interest: Dams",
          },
          {
            name: i18n.translate(
              "categories.landmarkspointsofinterest.caverns"
            ),
            id: "Landmarks & Points of Interest: Caverns",
          },
        ],
        volunteeropportunities: [
          {
            name: i18n.translate(
              "categories.volunteeropportunities.artsandculture"
            ),
            id: "Volunteer Opportunities: Arts & Culture",
          },
          {
            name: i18n.translate(
              "categories.volunteeropportunities.environment"
            ),
            id: "Volunteer Opportunities: Environment",
          },
        ],
        accommodations: [
          {
            name: i18n.translate("categories.accommodations.bedandbreakfasts"),
            id: "Accommodations: Bed & Breakfasts",
          },
          {
            name: i18n.translate(
              "categories.accommodations.condosandapartmentrentals"
            ),
            id: "Accommodations: Condos & Apartment Rentals",
          },
          {
            name: i18n.translate(
              "categories.accommodations.smallinnsguesthouses"
            ),
            id: "Accommodations: Small Inns & Guest Houses",
          },
          {
            name: i18n.translate("categories.accommodations.housevillarentals"),
            id: "Accommodations: House & Villa Rentals",
          },
          {
            name: i18n.translate("categories.accommodations.hotels"),
            id: "Accommodations: Hotels",
          },
          {
            name: i18n.translate("categories.accommodations.resorts"),
            id: "Accommodations: Resorts",
          },
          {
            name: i18n.translate("categories.accommodations.homestays"),
            id: "Accommodations: Homestays",
          },
          {
            name: i18n.translate(
              "categories.accommodations.campgroundstentsites"
            ),
            id: "Accommodations: Campgrounds - Tent Sites",
          },
          {
            name: i18n.translate(
              "categories.accommodations.campgroundstrailersites"
            ),
            id: "Accommodations: Campgrounds - Trailer Sites",
          },
          {
            name: i18n.translate(
              "categories.accommodations.hostelsbackpackers"
            ),
            id: "Accommodations: Hostels / Backpackers",
          },
          {
            name: i18n.translate("categories.accommodations.uniquerentals"),
            id: "Accommodations: Unique Rentals",
          },
          {
            name: i18n.translate("categories.accommodations.glamping"),
            id: "Accommodations: Glamping",
          },
          {
            name: i18n.translate("categories.accommodations.paradores"),
            id: "Accommodations: Paradores",
          },
          {
            name: i18n.translate("categories.accommodations.motels"),
            id: "Accommodations: Motels",
          },
        ],
        attractions: [
          {
            name: i18n.translate("categories.attractions.artgalleries"),
            id: "Attractions: Art Galleries",
          },
          {
            name: i18n.translate("categories.attractions.amusementparks"),
            id: "Attractions: Amusement Parks",
          },
          {
            name: i18n.translate("categories.attractions.waterparks"),
            id: "Attractions: Water Parks",
          },
          {
            name: i18n.translate("categories.attractions.movietheaterscinemas"),
            id: "Attractions: Movie Theaters / Cinemas",
          },
          {
            name: i18n.translate(
              "categories.attractions.wildliferefugesnaturereserves"
            ),
            id: "Attractions: Wildlife Refuges & Nature Reserves",
          },
          {
            name: i18n.translate("categories.attractions.thermalpools"),
            id: "Attractions: Thermal Pools",
          },
          {
            name: i18n.translate("categories.attractions.nationalparks"),
            id: "Attractions: National Parks",
          },
          {
            name: i18n.translate("categories.attractions.naturecenters"),
            id: "Attractions: Nature Centers",
          },
          {
            name: i18n.translate("categories.attractions.agritourism"),
            id: "Attractions: Agritourism",
          },
          {
            name: i18n.translate("categories.attractions.distilleries"),
            id: "Attractions: Distilleries",
          },
          {
            name: i18n.translate("categories.attractions.casinos"),
            id: "Attractions: Casinos",
          },
          {
            name: i18n.translate("categories.attractions.eventticketing"),
            id: "Attractions: Event Ticketing",
          },
          {
            name: i18n.translate("categories.attractions.escaperooms"),
            id: "Attractions: Escape Rooms",
          },
          {
            name: i18n.translate("categories.attractions.horseracing"),
            id: "Attractions: Horse Racing",
          },
          {
            name: i18n.translate("categories.attractions.botanicalgardens"),
            id: "Attractions: Botanical Gardens",
          },
          {
            name: i18n.translate("categories.attractions.danceshows"),
            id: "Attractions: Dance Shows",
          },
        ],
        dining: [
          {
            name: i18n.translate("categories.dining.foodstands"),
            id: "Dining: Food Stands",
          },
          {
            name: i18n.translate("categories.dining.chinchorros"),
            id: "Dining: Chinchorros",
          },
          {
            name: i18n.translate("categories.dining.restaurants"),
            id: "Dining: Restaurants",
          },
          {
            name: i18n.translate("categories.dining.pubssportsbars"),
            id: "Dining: Pubs & Sports Bars",
          },
          {
            name: i18n.translate("categories.dining.cafeterias"),
            id: "Dining: Cafeterias",
          },
          {
            name: i18n.translate("categories.dining.bistrosloungesgastropubs"),
            id: "Dining: Bistros, Lounges & Gastropubs",
          },
          {
            name: i18n.translate("categories.dining.bakeriespastryshops"),
            id: "Dining: Bakeries / Pastry Shops",
          },
          {
            name: i18n.translate("categories.dining.coffeeshops"),
            id: "Dining: Coffee Shops",
          },
          {
            name: i18n.translate("categories.dining.foodtrucks"),
            id: "Dining: Food Trucks",
          },
          {
            name: i18n.translate("categories.dining.specialtyfoodshops"),
            id: "Dining: Specialty Food Shops",
          },
          {
            name: i18n.translate("categories.dining.delis"),
            id: "Dining: Delis",
          },
          {
            name: i18n.translate("categories.dining.breweries"),
            id: "Dining: Breweries",
          },
          {
            name: i18n.translate("categories.dining.fastfood"),
            id: "Dining: Fast Food",
          },
          {
            name: i18n.translate("categories.dining.diners"),
            id: "Dining: Diners",
          },
        ],
        eventservices: [
          {
            name: i18n.translate("categories.eventservices.travelagencies"),
            id: "Event Services: Travel Agencies",
          },
          {
            name: i18n.translate(
              "categories.eventservices.eventcoordinatorsmeetingplanners"
            ),
            id: "Event Services: Event Coordinators & Meeting Planners",
          },
          {
            name: i18n.translate(
              "categories.eventservices.eventmanagementcompanies"
            ),
            id: "Event Services: Event Management Companies",
          },
          {
            name: i18n.translate("categories.eventservices.catering"),
            id: "Event Services: Catering",
          },
          {
            name: i18n.translate(
              "categories.eventservices.airfreightpackagesshipping"
            ),
            id: "Event Services: Air Freight, Packages & Shipping",
          },
          {
            name: i18n.translate(
              "categories.eventservices.groupfriendlyactivitiestours"
            ),
            id: "Event Services: Group-Friendly Activities & Tours",
          },
          {
            name: i18n.translate(
              "categories.eventservices.tourgroundoperatorscharters"
            ),
            id: "Event Services: Tour & Ground Operators / Charters",
          },
          {
            name: i18n.translate(
              "categories.eventservices.trainingteambuildingcompanies"
            ),
            id: "Event Services: Training & Teambuilding Companies",
          },
          {
            name: i18n.translate("categories.eventservices.weddingphotography"),
            id: "Event Services: Wedding Photography",
          },
          {
            name: i18n.translate("categories.eventservices.eventphotography"),
            id: "Event Services: Event Photography",
          },
          {
            name: i18n.translate(
              "categories.eventservices.weddingplannerscoordinators"
            ),
            id: "Event Services: Wedding Planners & Coordinators",
          },
          {
            name: i18n.translate(
              "categories.eventservices.musiciansentertainers"
            ),
            id: "Event Services: Musicians & Entertainers",
          },
          {
            name: i18n.translate(
              "categories.eventservices.healthspaswellnessprograms"
            ),
            id: "Event Services: Health Spas / Wellness Programs",
          },
          {
            name: i18n.translate("categories.eventservices.flowersdecoration"),
            id: "Event Services: Flowers & Decoration",
          },
          {
            name: i18n.translate(
              "categories.eventservices.linenchairtablerentals"
            ),
            id: "Event Services: Linen, Chair & Table Rentals",
          },
          {
            name: i18n.translate(
              "categories.eventservices.signsdisplaysgraphicsprinting"
            ),
            id: "Event Services: Signs & Displays / Graphics / Printing",
          },
          {
            name: i18n.translate(
              "categories.eventservices.workshopseminarspeakers"
            ),
            id: "Event Services: Workshop & Seminar Speakers",
          },
          {
            name: i18n.translate("categories.eventservices.audiovisual"),
            id: "Event Services: Audiovisual",
          },
          {
            name: i18n.translate("categories.eventservices.lightsoundeffects"),
            id: "Event Services: Light & Sound Effects",
          },
          {
            name: i18n.translate(
              "categories.eventservices.serviceprofessionals"
            ),
            id: "Event Services: Service Professionals",
          },
          {
            name: i18n.translate("categories.eventservices.hairmakeup"),
            id: "Event Services: Hair & Makeup",
          },
          {
            name: i18n.translate(
              "categories.eventservices.foreignlanguagespecialists"
            ),
            id: "Event Services: Foreign Language Specialists",
          },
          {
            name: i18n.translate(
              "categories.eventservices.promoitemsawardsgifts"
            ),
            id: "Event Services: Promo Items, Awards & Gifts",
          },
          {
            name: i18n.translate(
              "categories.eventservices.tempstaffingemploymentservices"
            ),
            id: "Event Services: Temp Staffing & Employment Services",
          },
          {
            name: i18n.translate(
              "categories.eventservices.groupfriendlyattractions"
            ),
            id: "Event Services: Group-Friendly Attractions",
          },
          {
            name: i18n.translate(
              "categories.eventservices.destinationmanagementcompanies"
            ),
            id: "Event Services: Destination Management Companies",
          },
          {
            name: i18n.translate(
              "categories.eventservices.musicentertainmentpromoters"
            ),
            id: "Event Services: Music & Entertainment Promoters",
          },
          {
            name: i18n.translate(
              "categories.eventservices.webcastinginternetservices"
            ),
            id: "Event Services: Webcasting & Internet Services",
          },
          {
            name: i18n.translate("categories.eventservices.finepastries"),
            id: "Event Services: Fine Pastries",
          },
          {
            name: i18n.translate(
              "categories.eventservices.expositiontradeshowcontractors"
            ),
            id: "Event Services: Exposition & Tradeshow Contractors",
          },
          {
            name: i18n.translate("categories.eventservices.travelwholesalers"),
            id: "Event Services: Travel Wholesalers",
          },
          {
            name: i18n.translate(
              "categories.eventservices.securitysystemcompanies"
            ),
            id: "Event Services: Security System Companies",
          },
          {
            name: i18n.translate("categories.eventservices.officesupplies"),
            id: "Event Services: Office Supplies",
          },
          {
            name: i18n.translate(
              "categories.eventservices.computerrentaldataprocessingit"
            ),
            id: "Event Services: Computer Rental, Data Processing & IT",
          },
        ],
        eventvenues: [
          {
            name: i18n.translate("categories.eventvenues.accommodationonsite"),
            id: "Event Venues: Accommodation On Site",
          },
          {
            name: i18n.translate("categories.eventvenues.meetingrooms"),
            id: "Event Venues: Meeting Rooms",
          },
          {
            name: i18n.translate("categories.eventvenues.conferencecenters"),
            id: "Event Venues: Conference Centers",
          },
          {
            name: i18n.translate("categories.eventvenues.groupdiningvenues"),
            id: "Event Venues: Group Dining Venues",
          },
          {
            name: i18n.translate(
              "categories.eventvenues.noaccommodationonsite"
            ),
            id: "Event Venues: No Accommodation on Site",
          },
          {
            name: i18n.translate("categories.eventvenues.ceremonyvenues"),
            id: "Event Venues: Ceremony Venues",
          },
          {
            name: i18n.translate("categories.eventvenues.receptionvenues"),
            id: "Event Venues: Reception Venues",
          },
          {
            name: i18n.translate("categories.eventvenues.conventioncenters"),
            id: "Event Venues: Convention Centers",
          },
          {
            name: i18n.translate("categories.eventvenues.ballrooms"),
            id: "Event Venues: Ballrooms",
          },
          {
            name: i18n.translate("categories.eventvenues.banquetvenues"),
            id: "Event Venues: Banquet Venues",
          },
          {
            name: i18n.translate("categories.eventvenues.theatershowvenues"),
            id: "Event Venues: Theater / Show Venues",
          },
          {
            name: i18n.translate("categories.eventvenues.concertvenues"),
            id: "Event Venues: Concert Venues",
          },
          {
            name: i18n.translate("categories.eventvenues.stadiums"),
            id: "Event Venues: Stadiums",
          },
        ],
        medicaltourism: [
          {
            name: i18n.translate("categories.medicaltourism.dental"),
            id: "Medical Tourism: Dental",
          },
          {
            name: i18n.translate("categories.medicaltourism.hospitals"),
            id: "Medical Tourism: Hospitals",
          },
        ],
        museums: [
          {
            name: i18n.translate("categories.museums.historymuseums"),
            id: "Museums: History Museums",
          },
          {
            name: i18n.translate("categories.museums.artmuseums"),
            id: "Museums: Art Museums",
          },
          {
            name: i18n.translate("categories.museums.sciencemuseums"),
            id: "Museums: Science Museums",
          },
          {
            name: i18n.translate("categories.museums.archaeologymuseums"),
            id: "Museums: Archaeology Museums",
          },
          {
            name: i18n.translate("categories.museums.agriculturemuseums"),
            id: "Museums: Agriculture Museums",
          },
          {
            name: i18n.translate("categories.museums.musicmuseums"),
            id: "Museums: Music Museums",
          },
          {
            name: i18n.translate(
              "categories.museums.folkloreindigenousmuseums"
            ),
            id: "Museums: Folklore & Indigenous Museums",
          },
        ],
        nightlife: [
          {
            name: i18n.translate("categories.nightlife.danceclubs"),
            id: "Nightlife: Dance Clubs",
          },
          {
            name: i18n.translate("categories.nightlife.karaoke"),
            id: "Nightlife: Karaoke",
          },
          {
            name: i18n.translate("categories.nightlife.sportsbars"),
            id: "Nightlife: Sports Bars",
          },
          {
            name: i18n.translate("categories.nightlife.comedyclubs"),
            id: "Nightlife: Comedy Clubs",
          },
          {
            name: i18n.translate("categories.nightlife.livemusic"),
            id: "Nightlife: Live Music",
          },
          {
            name: i18n.translate("categories.nightlife.lounges"),
            id: "Nightlife: Lounges",
          },
          {
            name: i18n.translate("categories.nightlife.cocktailbars"),
            id: "Nightlife: Cocktail Bars",
          },
          {
            name: i18n.translate("categories.nightlife.cigarbars"),
            id: "Nightlife: Cigar Bars",
          },
          {
            name: i18n.translate("categories.nightlife.speakeasies"),
            id: "Nightlife: Speakeasies",
          },
          {
            name: i18n.translate("categories.nightlife.gaybars"),
            id: "Nightlife: Gay Bars",
          },
          {
            name: i18n.translate("categories.nightlife.winebars"),
            id: "Nightlife: Wine Bars",
          },
        ],
        shopping: [
          {
            name: i18n.translate("categories.shopping.clothingstores"),
            id: "Shopping: Clothing Stores",
          },
          {
            name: i18n.translate("categories.shopping.specialtyshops"),
            id: "Shopping: Specialty Shops",
          },
          {
            name: i18n.translate(
              "categories.shopping.sportsoutdoorsoutfitters"
            ),
            id: "Shopping: Sports / Outdoors Outfitters",
          },
          {
            name: i18n.translate("categories.shopping.giftshops"),
            id: "Shopping: Gift Shops",
          },
          {
            name: i18n.translate("categories.shopping.shoppingcentersplazas"),
            id: "Shopping: Shopping Centers / Plazas",
          },
          {
            name: i18n.translate("categories.shopping.artsandcrafts"),
            id: "Shopping: Arts & Crafts",
          },
          {
            name: i18n.translate("categories.shopping.madeinpuertorico"),
            id: "Shopping: Made in Puerto Rico",
          },
          {
            name: i18n.translate("categories.shopping.grocerystores"),
            id: "Shopping: Grocery Stores",
          },
          {
            name: i18n.translate("categories.shopping.malls"),
            id: "Shopping: Malls",
          },
          {
            name: i18n.translate("categories.shopping.jewelrystores"),
            id: "Shopping: Jewelry Stores",
          },
          {
            name: i18n.translate("categories.shopping.departmentstores"),
            id: "Shopping: Department Stores",
          },
          {
            name: i18n.translate("categories.shopping.fleamarkets"),
            id: "Shopping: Flea Markets",
          },
          {
            name: i18n.translate("categories.shopping.openairmarkets"),
            id: "Shopping: Open-Air Markets",
          },
          {
            name: i18n.translate("categories.shopping.boutiques"),
            id: "Shopping: Boutiques",
          },
          {
            name: i18n.translate("categories.shopping.farmersmarkets"),
            id: "Shopping: Farmers' Markets",
          },
          {
            name: i18n.translate("categories.shopping.outlets"),
            id: "Shopping: Outlets",
          },
        ],
        sportsmarketing: [
          {
            name: i18n.translate(
              "categories.sportsmarketing.associationsfederations"
            ),
            id: "Sports Marketing: Associations & Federations",
          },
          {
            name: i18n.translate("categories.sportsmarketing.baseballvenues"),
            id: "Sports Marketing: Baseball Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.basketballvenues"),
            id: "Sports Marketing: Basketball Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.swimmingvenues"),
            id: "Sports Marketing: Swimming Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.tennisvenues"),
            id: "Sports Marketing: Tennis Venues",
          },
          {
            name: i18n.translate(
              "categories.sportsmarketing.trackandfieldvenues"
            ),
            id: "Sports Marketing: Track & Field Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.volleyballvenues"),
            id: "Sports Marketing: Volleyball Venues",
          },
          {
            name: i18n.translate(
              "categories.sportsmarketing.soccerfootballvenues"
            ),
            id: "Sports Marketing: Soccer / Football Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.golfvenues"),
            id: "Sports Marketing: Golf Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.softballvenues"),
            id: "Sports Marketing: Softball Venues",
          },
          {
            name: i18n.translate(
              "categories.sportsmarketing.fishingtournamentvenues"
            ),
            id: "Sports Marketing: Fishing Tournament Venues",
          },
          {
            name: i18n.translate(
              "categories.sportsmarketing.martialartsvenues"
            ),
            id: "Sports Marketing: Martial Arts Venues",
          },
          {
            name: i18n.translate(
              "categories.sportsmarketing.skateboardingvenues"
            ),
            id: "Sports Marketing: Skateboarding Venues",
          },
          {
            name: i18n.translate("categories.sportsmarketing.sportspromoters"),
            id: "Sports Marketing: Sports Promoters",
          },
        ],
        tours: [
          {
            name: i18n.translate("categories.tours.adventuretours"),
            id: "Tours: Adventure Tours",
          },
          {
            name: i18n.translate("categories.tours.guidedtours"),
            id: "Tours: Guided Tours",
          },
          {
            name: i18n.translate("categories.tours.boattours"),
            id: "Tours: Boat Tours",
          },
          {
            name: i18n.translate("categories.tours.cavetours"),
            id: "Tours: Cave Tours",
          },
          {
            name: i18n.translate("categories.tours.natureecotours"),
            id: "Tours: Nature & Eco Tours",
          },
          {
            name: i18n.translate("categories.tours.sightseeingtours"),
            id: "Tours: Sightseeing Tours",
          },
          {
            name: i18n.translate("categories.tours.studentyouthtours"),
            id: "Tours: Student & Youth Tours",
          },
          {
            name: i18n.translate("categories.tours.culturaltours"),
            id: "Tours: Cultural Tours",
          },
          {
            name: i18n.translate("categories.tours.biketours"),
            id: "Tours: Bike Tours",
          },
          {
            name: i18n.translate("categories.tours.historicaltours"),
            id: "Tours: Historical Tours",
          },
          {
            name: i18n.translate("categories.tours.foodtours"),
            id: "Tours: Food Tours",
          },
          {
            name: i18n.translate("categories.tours.walkingtours"),
            id: "Tours: Walking Tours",
          },
          {
            name: i18n.translate("categories.tours.agriculturaltours"),
            id: "Tours: Agricultural Tours",
          },
          {
            name: i18n.translate("categories.tours.shoppingtours"),
            id: "Tours: Shopping Tours",
          },
          {
            name: i18n.translate("categories.tours.nighttours"),
            id: "Tours: Night Tours",
          },
          {
            name: i18n.translate("categories.tours.drivingtours"),
            id: "Tours: Driving Tours",
          },
          {
            name: i18n.translate("categories.tours.distillerytours"),
            id: "Tours: Distillery Tours",
          },
          {
            name: i18n.translate("categories.tours.bustrolleytours"),
            id: "Tours: Bus & Trolley Tours",
          },
          {
            name: i18n.translate("categories.tours.motorcycletours"),
            id: "Tours: Motorcycle Tours",
          },
        ],
        transportation: [
          {
            name: i18n.translate("categories.transportation.airports"),
            id: "Transportation: Airports",
          },
          {
            name: i18n.translate("categories.transportation.airlines"),
            id: "Transportation: Airlines",
          },
          {
            name: i18n.translate("categories.transportation.buses"),
            id: "Transportation: Buses",
          },
          {
            name: i18n.translate(
              "categories.transportation.luxurytransportation"
            ),
            id: "Transportation: Luxury Transportation",
          },
          {
            name: i18n.translate(
              "categories.transportation.privatetransportation"
            ),
            id: "Transportation: Private Transportation",
          },
          {
            name: i18n.translate("categories.transportation.carvanrentals"),
            id: "Transportation: Car / Van Rentals",
          },
          {
            name: i18n.translate(
              "categories.transportation.aircraftchartershelicopter"
            ),
            id: "Transportation: Aircraft Charters - Helicopter",
          },
          {
            name: i18n.translate("categories.transportation.taxis"),
            id: "Transportation: Taxis",
          },
        ],
        wellness: [
          {
            name: i18n.translate("categories.wellness.gymsfitnesscenters"),
            id: "Wellness: Gyms & Fitness Centers",
          },
          {
            name: i18n.translate("categories.wellness.yoga"),
            id: "Wellness: Yoga",
          },
          {
            name: i18n.translate("categories.wellness.spas"),
            id: "Wellness: Spas",
          },
          {
            name: i18n.translate("categories.wellness.meditation"),
            id: "Wellness: Meditation",
          },
        ],
      },
      filterOpen: false,
      logo: null,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onSelect2 = this.onSelect2.bind(this);

    this.onRemove = this.onRemove.bind(this);
    this.onRemove2 = this.onRemove2.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get("mobile") || params.get("header") === "false") {
      mobile = true;
    }
    this.setState({ mobile: mobile, width: width });

    if (width < 800) {
      this.getHotelsList();
    }
    this.getLogo();
    this.setState({
      language: JSON.parse(
        localStorage.getItem("lang")
      ).rawData.langFile.toLowerCase(),
    });
  }

  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
      });
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true, freeHotelsList: [] });
    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        cuisine,
        michelin,
        rating,
        subcategory,
      } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        cuisine,
        michelin,
        rating,
        subcategory
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 20,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 9,
      center: {
        lat: 18.220833,
        lng: -66.290149,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    document.getElementById("iframe").classList.remove("hide");
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
    });
  };

  freeInfo = (userInfoID) => {
    // console.log(userInfoID);
    // Get language from local storage
    // const language = JSON.parse(localStorage.getItem("lang")) || {};

    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=130&mobile=true&header=false&lang=${this.state.language}`,
        "*"
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=13&mobile=true&header=false&lang=${this.state.language}`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=13&lang=${this.state.language}`,
      });
    }
  };

  onSelect = (selectedList, selectedItem) => {
    this.setState(
      {
        category: selectedItem.id,
        subcategory: "",
      },
      this.getHotelsList
    );
  };

  onRemove(selectedList, removedItem) {
    this.setState(
      {
        category: "",
        subcategory: "",
      },
      this.getHotelsList
    );
  }

  onSelect2 = (selectedList, selectedItem) => {
    console.log();

    this.setState(
      {
        subcategory: selectedItem["id"],
      },
      () => {
        this.getHotelsList();
      }
    );
  };

  onRemove2(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem["name"]);

    this.setState(
      {
        subcategory: "",
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  transformOptions = (options) => {
    return options.map((option) => ({ name: option }));
  };

  handleCheck = (e) => {
    if (this.state[e.target.id] === "") {
      this.setState(
        {
          [e.target.id]: 1,
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      this.setState(
        {
          [e.target.id]: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  };

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      width,
      loading,
      filterOpen,
      logo,
      category,
      subcategories,
      subcategory,
      language,
    } = this.state;

    const normalizedCategory = category
      .replace(/ /g, "")
      .replace(/&/g, "")
      .replace(/:/g, "")
      .replace(/,/g, "")
      .toLowerCase();

    let options = subcategories[normalizedCategory] || [];
    // Flatten the array
    options = options.reduce((acc, val) => acc.concat(val), []);

    console.log(subcategory, options, subcategories, normalizedCategory);
    return (
      <div className="directoryContainer">
        {!mobile && (
          <div className="header">
            <BackButton
              useHistory={false}
              text={i18n.translate("general.back")}
            />
            <div className="search">
              <FontAwesomeIcon
                icon={["fas", "search"]}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder={i18n.translate("directoryView.search")}
                type="text"
                ref={(input) => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={logo} className="logo" alt="logo" />
          </div>
        )}
        {mobile && (
          <style>
            {
              "\
              .cookieConsent { display: none !important; } .directoryContainer { height: 100vh; } .results { top: 0 !important; } .listContainer { height: calc(100vh - 22rem) !important; margin-top: 0 !important; } @media screen and (min-width: 699px) { .listContainer { height: calc(100vh - 18rem) !important; } }"
            }
          </style>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directoryView.amountOfResults")}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate("general.close")
                  : i18n.translate("directoryView.filter")}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                <div className="type">
                  <Multiselect
                    options={this.state.categories}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder={i18n.translate("directoryView.filter")}
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                    singleSelect={true}
                  />
                </div>

                {category && options.length > 0 && (
                  <div className="subcategory" key={category}>
                    <Multiselect
                      options={options}
                      selectedValues={this.state.selectedValue}
                      onSelect={this.onSelect2}
                      onRemove={this.onRemove2}
                      displayValue="name"
                      placeholder={i18n.translate("directoryView.subFilter")}
                      showArrow={true}
                      avoidHighlightFirstOption={true}
                      singleSelect={true}
                    />
                  </div>
                )}

                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directoryView.resetFilters")} >
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directoryView.resetFilters")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directoryView.showResults")}
                  </button>
                </div>
              </div>

              {mobile && (
                <div className="search">
                  <FontAwesomeIcon
                    icon={["fas", "search"]}
                    className="searchIcon"
                  />
                  <input
                    className="searchInput"
                    placeholder={i18n.translate("directoryView.search")}
                    type="text"
                    ref={(input) => (this.search = input)}
                    onChange={this.handleInputChange}
                  />
                </div>
              )}

              <SimpleBarReact
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directoryView.noResults")}
                    </div>
                  )}
                  {/* Filter duplicates, because items are created for each category and can't have multiple */}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel, i) => (
                      <React.Fragment key={hotel.company_listing_id}>
                        <FreeHotel
                          id={hotel.company_listing_id}
                          bgImage={hotel.img_path + hotel.photo_file}
                          flyToMarker={() => {
                            this.flyToMarker(hotel.latitude, hotel.longitude);
                          }}
                          hotelInfo={() => {
                            this.freeInfo(hotel.listing_id);
                          }}
                          hotelName={hotel.company}
                          location={hotel.state}
                          item={hotel}
                        />
                      </React.Fragment>
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {i18n.translate("directoryView.resetMap")}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript
                googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc"
                language={language}
              >
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("general.back")}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
